import * as React from "react";

import { ITheme, mergeStyles } from "@fluentui/react/lib/Styling";

import { dataUniqueId } from "@1js/acui-common";
import {
  AppFullGallery,
  AppFullGalleryProps,
  AppGalleryButton,
  AppGalleryButtonProps,
  getGalleryWidth,
} from "@1js/acui-gallery";
import { AppThemeConsumer } from "@1js/acui-theme";

import {
  galleryButtonWidth,
  getPageNumberGalleryStyles,
  getPageNumberPositionStyles,
  pageNumberPageStyles,
} from "./RibbonPageNumberGallery.styles";

export interface RibbonPageNumberGalleryButtonProps
  extends AppGalleryButtonProps {
  /**
   * The text to display in the button.
   */
  text: string;
}

export interface RibbonPageNumberFullGalleryProps
  extends AppFullGalleryProps<RibbonPageNumberGalleryButtonProps> {
  type: "RibbonPageNumberFullGalleryProps";
}

const RibbonPageNumberGalleryButton: React.StatelessComponent<RibbonPageNumberGalleryButtonProps> =
  React.memo((props: RibbonPageNumberGalleryButtonProps) => {
    const index = props.index !== undefined ? props.index : 0;
    return (
      <AppThemeConsumer>
        {(theme: ITheme) => (
          <AppGalleryButton
            {...props}
            automationType="RibbonPageNumber"
            uniqueId={props.id}
            shouldTakeFocus={
              props.shouldTakeFocus !== undefined ? props.shouldTakeFocus : true
            }
            title={undefined}
            label={props.title}
            ariaLabel={props.title}
          >
            <div className={mergeStyles(pageNumberPageStyles(theme))}>
              <div className={mergeStyles(getPageNumberPositionStyles(index))}>
                {props.text}
              </div>
            </div>
          </AppGalleryButton>
        )}
      </AppThemeConsumer>
    );
  });

export class RibbonPageNumberGallery extends React.PureComponent<
  RibbonPageNumberFullGalleryProps,
  {}
> {
  public render() {
    const { columns, defaultWidth, styles } = this.props;
    return (
      <AppThemeConsumer>
        {(theme: ITheme) => (
          <AppFullGallery
            {...this.props}
            getGalleryButtonComponent={RibbonPageNumberGalleryButton}
            styles={getPageNumberGalleryStyles(theme, styles)}
            data-automation-type="RibbonPageNumberGallery"
            data-unique-id={dataUniqueId(this.props)}
            defaultWidth={
              defaultWidth ||
              getGalleryWidth(columns, galleryButtonWidth, styles)
            }
          />
        )}
      </AppThemeConsumer>
    );
  }
}
